import { LoadingCard } from '@/components/Base/LoadingCard/LoadingCard'
import { NoDataToDisplayCard } from '@/components/Base/NoDataToDisplayCard/NoDataToDisplayCard'
import { useAppSelector } from '@/hooks/use-app-selector'
import { IConstraintReport } from '@/interfaces/portfolioOptimization.interface'
import { getConstraintReport } from '@/services/portfolio-optimization/optimization-reports.service'
import { showSnackbar } from '@/states/snackbar.slice'
import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import './ConstraintReport.module.scss'

const ConstraintReport: React.FC = () => {
  const appDispatch = useDispatch()
  const selectedReport =
    useAppSelector((s) => s.axiomReport.selectedReport) || {}
  const [constraintReportData, setConstraintReportData] =
    useState<IConstraintReport>({} as IConstraintReport)
  const [showLoader, setShowLoader] = useState<boolean>(true)

  useEffect(() => {
    setShowLoader(true)
    const fetchConstraintReport = async () => {
      try {
        const response = await getConstraintReport(selectedReport.reportId)
        setConstraintReportData(response)
      } catch (err) {
        appDispatch(
          showSnackbar({
            message: `Error fetching constraint report ${err instanceof Error ? err.message : String(err)}`,
            severity: 'error',
          }),
        )
        setConstraintReportData({} as IConstraintReport)
      } finally {
        setShowLoader(false)
      }
    }
    fetchConstraintReport()
  }, [selectedReport.reportId, appDispatch])

  return (
    <>
      {showLoader ? (
        <LoadingCard />
      ) : constraintReportData?.constraint_report ? (
        <Box className='constraint-report-section'>
          {
            <ul className='constraintReportList'>
              {constraintReportData?.constraint_report?.split('\n').map(
                (constraintItem, index) =>
                  constraintItem?.trim().length > 0 && (
                    <li key={index}>
                      <Typography
                        variant='h5'
                        color='textSecondary'
                        px={1}
                        margin={1}
                      >
                        {constraintItem}
                        <br />
                      </Typography>
                    </li>
                  ),
              )}
            </ul>
          }
        </Box>
      ) : (
        <NoDataToDisplayCard />
      )}
    </>
  )
}

export default ConstraintReport
